import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  colors,
  Container,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Row, Col, Spinner } from "react-bootstrap";
import API from "../../../../network/dashboardAPI";
import moment from "moment";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TablePagination,
} from "@material-ui/core";
import {
  Label,
  ListAlt,
  PermContactCalendar,
  ShoppingBasket,
  ShoppingCart,
} from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import { baseUrl } from "../../../../constants/Constant";
import { backgroundColor } from "styled-system";
import DeleteIcon from "@material-ui/icons/Delete";
import DateTimePicker from "react-datetime";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const StoreOngoingSlot = () => {
  /**
   */
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [dayNumber, setDayNumber] = useState(0);
  const [storeOnOff, setStoreOnOff] = useState(true);
  const [stopAccept, setStopAccept] = useState(false);
  const [totalAccept, setTotalAccept] = useState(0);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState("");
  const [slotId, setSlotId] = useState(null);
  const [list, setList] = useState([]);
  const [type, setType] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const handleChange = (event) => {
    setDayNumber(event.target.value);
  };

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const reset = () => {
    setSlotId(null);
    setEndDate("");
    setStartDate("");
    setStopAccept(false);
    setDayNumber(0);
    setStoreOnOff(true);
    setTotalAccept(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value));
  };

  const formatDate = (date) => moment(date, "HH:mm").format("HH:mm");
  const changeDate = (date, field) => {
    let newDate = formatDate(date);
    console.log(newDate);
    switch (field) {
      case "start_date":
        return setStartDate(newDate);
      case "end_date":
        return setEndDate(newDate);
      default:
        return;
    }
  };

  const handleClickSetup = (type, data = null) => {
    setOpen(!open);
    switch (type) {
      case "update": {
        setType("Update");
        setStartDate(data.start_time);
        setEndDate(data.end_time);
        setTotalAccept(data?.total_order_to_accept);
        setDayNumber(data?.day_number);
        setStoreOnOff(data?.store_on_off === 0 ? false : true);
        setSlotId(data?.slot_setting_id);
        break;
      }
      default: {
        setType("Create");
        break;
      }
    }
  };
  const clodeModal = () => {
    reset();
    setOpen(false);
  };
  const getSlotSlotSettings = async () => {
    setLoading(true);
    let body = {
      page: page,
      limit: rowsPerPage,
      store_id: 1,
    };
    if (startDateFilter) {
      body.start_date = startDateFilter;
    }
    if (endDateFilter) {
      body.end_date = endDateFilter;
    }
    await API.getSlotSettings(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setList(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching ongoing slots:", error); // Handle errors
      });
  };
  const updateSlotSettingsOnOff = async (data, store_on_off) => {
    console.log(data);
    let body = {
      slot_setting_id: data.slot_setting_id,
      store_on_off: store_on_off,
    };
    await API.updateSlotSettingsOnOff(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          getSlotSlotSettings();
        }
      })
      .catch((error) => {
        console.error("Error fetching ongoing slots:", error); // Handle errors
      });
  };
  const createSlotSettings = async () => {
    await API.createSlotSettings({
      start_time: startDate,
      end_time: endDate,
      store_id: 1,
      day_number: dayNumber,
      total_order_to_accept: totalAccept,
      store_on_off: storeOnOff ? 1 : 0,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          getSlotSlotSettings();
          setOpen(!open);
        } else {
          console.error("Update failed:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error updating ongoing slot:", error);
      });
  };
  const updateStoreOngoingSlot = async () => {
    if (slotId) {
      await API.updateSlotSettings({
        slot_setting_id: slotId,
        start_time: startDate,
        end_time: endDate,
        store_id: 1,
        day_number: dayNumber,
        total_order_to_accept: totalAccept,
        store_on_off: storeOnOff ? 1 : 0,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.success) {
            getSlotSlotSettings();
            setOpen(!open);
          } else {
            console.error("Update failed:", data.message);
          }
        })
        .catch((error) => {
          console.error("Error updating ongoing slot:", error);
        });
    } else {
      console.error("Required fields are empty.");
    }
  };

  const clearFilter = () => {
    setPage(0);
    setStartDateFilter("");
    setEndDateFilter("");
  };

  const [confirmModal, setConfirmModal] = useState(false);
  const handleDelete = (slot_id) => {
    setConfirmModal(!confirmModal);
    setSlotId(slot_id);
  };
  const deleteSlot = async () => {
    if (slotId) {
      await API.AdminDeleteSlotSettings({
        slot_setting_id: slotId,
        store_id: 1,
      })
        .then((res) => res.json())
        .then(async (res) => {
          if (res.success) {
            await getSlotSlotSettings();
            setConfirmModal(false);
          }
        });
    }
  };
  const getDayName = (dayNumber) => {
    const daysOfWeek = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    return daysOfWeek[dayNumber - 1]; // Subtract 1 because array is 0-indexed
  };

  useEffect(() => {
    getSlotSlotSettings();
  }, [page, rowsPerPage]);

  return (
    <Box component="div" m={1}>
      <Paper className="p-2">
        <Typography className="pl-4 font-bold" variant="h6">
          Store Slot Settings Id
        </Typography>
        <Grid container spacing={1} className="my-2 pl-4">
          <Grid item sm={5}>
            <Button
              onClick={() => handleClickSetup("create")}
              variant="contained"
              color="primary"
            >
              <AddIcon /> Create Slot Settings
            </Button>
          </Grid>
        </Grid>
        <Container>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell component="th">Slot Setting ID</TableCell>
                  <TableCell component="th">Start Time</TableCell>
                  <TableCell component="th">End Time</TableCell>
                  <TableCell component="th">Day</TableCell>
                  <TableCell component="th">Total Accept Order</TableCell>
                  <TableCell component="th" align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: "100px" }}
                      >
                        <Grid item>
                          <CircularProgress size={40} color="primary" />
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ) : list.data.length ? (
                  list.data.map((item) => {
                    return (
                      <TableRow
                        // style={{
                        //   ...(item.stop_accepting_orders === 1 && {
                        //     backgroundColor: "#ef9a9a",
                        //   }),
                        //   ...(item.slot_expired == 1 && {
                        //     backgroundColor: "#C0BFBFB9",
                        //   }),
                        // }}
                        key={1}
                        hover
                      >
                        <TableCell>{item.slot_setting_id}</TableCell>
                        <TableCell>{item.start_time}</TableCell>
                        <TableCell>{item.end_time}</TableCell>
                        <TableCell>{getDayName(item.day_number)}</TableCell>
                        <TableCell>{item.total_order_to_accept}</TableCell>
                        <TableCell align="center">
                          <div className="display-flex">
                            <Tooltip title="stop accepted orders">
                              <Switch
                                checked={item.store_on_off == 1 ? true : false}
                                onChange={() =>
                                  updateSlotSettingsOnOff(
                                    item,
                                    item.store_on_off == 0 ? 1 : 0
                                  )
                                }
                                color="primary"
                                name="checkedB"
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                              />
                            </Tooltip>
                            <IconButton
                              onClick={() => handleClickSetup("update", item)}
                              aria-label="edit"
                            >
                              <EditIcon style={{ color: colors.blue[600] }} />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleDelete(item.slot_setting_id)}
                            >
                              <DeleteIcon style={{ color: colors.red[600] }} />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={list.total}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Container>
      </Paper>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={clodeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Setup Store Slot Setting"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <TextField
                fullWidth
                id="start_date"
                label="Start Time"
                type="time"
                value={startDate}
                // className={classes.textField}
                onChange={(e) => changeDate(e.target.value, "start_date")}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                fullWidth
                id="end_date"
                label="End Time"
                type="time"
                value={endDate}
                onChange={(e) => changeDate(e.target.value, "end_date")}
                // className={classes.textField}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <TextField
                fullWidth
                value={totalAccept}
                onChange={(e) => setTotalAccept(e.target.value)}
                type="number"
                id="outlined-basic"
                label="Total Accept Order"
                variant="outlined"
              />
            </Grid>
            <Grid item sm={12}>
              <FormControl fullWidth variant="outlined">
                <Select
                  fullWidth
                  value={dayNumber} // state that holds the selected day number
                  onChange={handleChange} // function to handle changes
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={1}>Monday</MenuItem>
                  <MenuItem value={2}>Tuesday</MenuItem>
                  <MenuItem value={3}>Wednesday</MenuItem>
                  <MenuItem value={4}>Thursday</MenuItem>
                  <MenuItem value={5}>Friday</MenuItem>
                  <MenuItem value={6}>Saturday</MenuItem>
                  <MenuItem value={7}>Sunday</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item sm={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={storeOnOff}
                    onChange={(e) => setStoreOnOff(e.target.checked)}
                    name="checked"
                    color="primary"
                  />
                }
                label="Store ON/OFF"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={clodeModal} color="secondary">
            Close
          </Button>
          {type == "Create" ? (
            <Button onClick={() => createSlotSettings()} color="primary">
              {type}
            </Button>
          ) : (
            <Button onClick={() => updateStoreOngoingSlot()} color="primary">
              {type}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDelete} // Change this to handle modal close without deleting
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          {"Delete Slot Setting Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to delete this slot Setting
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} color="secondary">
            Close
          </Button>
          <Button onClick={deleteSlot} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StoreOngoingSlot;
